module.exports = __webpack_public_path__ + "static/cta-music-republicain-82d57d1331335b4749022b1135b7d1f1.jpg";